// extracted by mini-css-extract-plugin
module.exports = {"siteTitle":"TemperatureComplianceTileContainer_siteTitle__2Wuio","index":"TemperatureComplianceTileContainer_index__1lwhf"};